import React from 'react';
import { useDispatch } from 'react-redux';
import { string } from 'yup';

import { flashMessageSuccess } from '../../store/session';
import { updateDrivingLicenseNumber } from '../../store/user';
import { TextInput } from '../Input/Input';
import { SubmitButton } from '../Input/SubmitButton';
import { useValidatedField } from '../Input/useField';
import { useForm } from '../Input/useForm';
import MobileModal from '../MobileModal';
import T from '../Translate';

interface Props {
  closeModal: (success?: boolean) => void;
}

export function MissingDrivingLicenseNumberModal(props: Props) {
  const dispatch: DispatchFunction = useDispatch();
  const [number, setNumber, setError] = useValidatedField('licenceNumber', '', string().required('global.required'));
  const [handleSubmit, form] = useForm([number], async () => {
    try {
      await dispatch(updateDrivingLicenseNumber(number.value));
      dispatch(flashMessageSuccess('drivingLicenseNumberModal.saved'));
      props.closeModal(true);
    } catch (error) {
      setError(error.message);
    }
  });

  return (
    <MobileModal onClose={() => props.closeModal(false)} opened size="md">
      <form className="modal-body" onSubmit={handleSubmit}>
        <T as="h4" id="drivingLicenseNumberModal.title" />
        <T as="p" id="drivingLicenseNumberModal.description" />

        <TextInput
          error={form.errors.licenceNumber}
          label="drivingLicenseNumberModal.label"
          onChange={setNumber}
          value={number.value}
        />

        <SubmitButton block className="mt-3" primary submitting={form.submitting}>
          <T id="drivingLicenseNumberModal.button" />
        </SubmitButton>
      </form>
    </MobileModal>
  );
}
